import QueryBuilder from "../QueryBuilder"

export default class CarouselRepository {
    constructor(protected contentName: string) {}

    async fetch() {
        const results = await new QueryBuilder()
            .buildQuery(this.contentName, [
                "bannerText",
                "text_highlight",
                "'subheaderText': simpleBlockContent",
                "carousel_container",
            ])
            .process()

        return results.getResultInfo()
    }
}
